<template>
  <div>
    <list
      row-key="OrderId"
      ref="list"
      unit="往来单位"
      :expand-all-row="false"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="true"
      :get-data-func="api.list"
      :show-expand="true"
      :unitList="unitListFun"
      @expand-change="expandChange"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="客户名称">
          <el-input clearable v-model="params.name" placeholder="请输入客户名称" />
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input clearable v-model="params.name" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input clearable v-model="params.name" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="订单日期">
          <el-date-picker
            v-model="params.value1"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="OrderNo" label="单据编号" />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
        </el-table-column>
        <el-table-column prop="CustomerName" label="客户名称">
          <template slot-scope="{row}">{{ row.CustomerName }}</template>
        </el-table-column>
        <el-table-column prop="Amount" label="订单金额" />
        <el-table-column prop="UpdateTime" label="预计交货日期" />
        <el-table-column prop="Status" label="状态">
          <template slot-scope="{row}">
            <span v-if="row.Status == 0">草稿</span>
            <span v-else-if="row.Status == 1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
      <template slot="expand">
        <el-table-column type="selection" align="center" fixed width="40" />
        <el-table-column prop="GoodsName" label="商品名称" min-width="110px" />
        <el-table-column prop="Model" label="规格型号" />
        <el-table-column prop="UnitName" label="主单位" width="90px" />
        <el-table-column prop="Quantity" label="主单位数量" width="90px" />
        <el-table-column prop="UnitName1" label="辅单位1" width="90px" />
        <el-table-column prop="Quantity1" label="辅单位数量1" width="90px" />
        <el-table-column prop="UnitName2" label="辅单位2" width="90px" />
        <el-table-column prop="Quantity2" label="辅单位数量2" width="90px" />
        <el-table-column prop="Quantity" label="需采购数量" min-width="160px" />
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    typeList: {
      default: () => [],
    },
  },
  beforeMount() {
    this.params.TradeUnitTypeList = this.typeList;
    if (this.typeList.length > 0) {
      this.v1 = this.typeList.indexOf(1) > -1;
      this.v2 = this.typeList.indexOf(2) > -1;
      this.v3 = this.typeList.indexOf(3) > -1;
    }
  },
  data() {
    return {
      unitList: {},
      api: require("@/api/sale/sales").default,
      params: {
        TradeUnitType: null,
        TradeUnitTypeList: [],
        Name: "",
        Code: "",
      },
      v1: true,
      v2: true,
      v3: true,
    };
  },
  methods: {
    unitListFun(data) {
      data.forEach((e) => {
        if (this.unitList.OrderId == e.OrderId && !e.expand) {
          e.OrderNo = e.OrderNo + " ";
          this.$set(e, 'expand', this.unitList.Data)
        }
      });
      this.$emit("table-change", data);
      return data;
    },
    expandChange(row) {
      this.api.getGoodsList(row.OrderId).then((res) => {
        this.unitList = { OrderId: row.OrderId, Data: res.Data };
        this.$nextTick(() => {
          this.$refs.list.getexpand()
        })
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
